import Details from 'components/Content/GameDetails/Details/Details';

export default Details;
